import { render, staticRenderFns } from "./ApplicationApplicant.vue?vue&type=template&id=2081d4b5&"
import script from "./ApplicationApplicant.vue?vue&type=script&lang=js&"
export * from "./ApplicationApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports